import Model from '@/models/Model'

export default class HrPreviredApvPaymentType extends Model {
    resource() {
        return 'hr_previred_apv_payment_type'
    }
}